/**
 * "모바일 버전 보기"(specs/037 FR-004) — `useSwitchToPc` 의 역방향. 화면 선택을 auto 로 되돌린 뒤 모바일 첫 화면(허용된 첫 탭 — 지도사 공고 검색 #204 · 기업 홈 specs/065)으로 보낸다.
 * 다음 워크스페이스 진입부터 다시 기기 판별(모바일 기기 → 모바일 화면)을 따른다.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/config/routes';
import { useUiModeStore } from '@/stores/uiMode';

export function useSwitchToMobile() {
  const navigate = useNavigate();
  const setUiMode = useUiModeStore((s) => s.setUiMode);
  return useCallback(() => {
    setUiMode('auto');
    navigate(ROUTES.workspace.mobile.root);
  }, [navigate, setUiMode]);
}
